import React, { useEffect, useState, useRef } from 'react'
import * as d3 from 'd3';
import '../styles/aon-graph.css';
import '../styles/task-selection.css';
import { graphValues, LANG } from './data';
import PmModuleStyle from '../styles/pm.module.css';
import Button from '../../common/Button';
import nodeA from '../assets/nodeA.png';
const AonGraph = ({ simObj, setSimObj, simObjCopy, setSimObjCopy, isEnabledSimulationBtn, setIsEnabledSimulationBtn, setToggleSimulation, pmPopup, setPmPopup, skipWalkThruPopups, focusPopUp, copyUiDataObject, setCopyUiDataObject, setCostParameters,saveSimulation }) => {
    const [uiDataObject, setUiDataObject] = useState({});
    const [selectedTask, setSelectedTask] = useState({});
    const [selectedDependentTask, setSelectedDependentTask] = useState({});
    const [prevSelectedTask, setPrevSelectedTask] = useState({});
    const isSave = useRef(false)
    const [saveData,setSaveData] = useState(false)
    const [originalSelectedTask, setOriginalSelectedTask] = useState({});
    const [showTaskSelectionPopup, setShowTaskSelectionPopup] = useState(false);
    const [selectedTaskIndex, setSelectedTaskIndex] = useState(null);
    const [selectedDependentTaskIndex, setSelectedDependentTaskIndex] = useState(null);
    const [selectedOptionType, setSelectedOptionType] = useState("");
    const [selectedRadioIndex, setSelectedRadioIndex] = useState(0);
    const [isTaskOptionChanged, setIsTaskOptionChanged] = useState(false);
    const [copyProjectProfitDays, setCopyProjectProfitDays] = useState({});
    const [dependentTasks, setDependantTasks] = useState([]);
    const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change OM-620
    let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const [overtimeData, setOvertimeData] = useState({
        cost: null, days: null
    });
    // var costParameters = []
    const [eventType, setEventType] = useState("");
    const [supplierData, setSupplierData] = useState({
        cost: selectedTask['localSupplierCost'],
        days: selectedTask['localSupplierDays'],
        suppilerName: selectedTask['localSuppilerOptionName'],
    });
    const taskOptionType = {
        SUB_CONTRACTOR: "Subcontractor",
        SUPPLIER: "Supplier"
    }
    let uiDataObjectBckp = useRef();
    let svg, nodes2 = [];
    let width = 650, height = 200;
    let X = width / 2, Y = height / 2, radius = 12;
    let getAlphabetIndex = function (txt) {
        return txt.charCodeAt(0) - 65;
    }
    window.graphdata = graphValues.graphdata;
    const getGradient = (color1, color2, x, y, radius) => {
        let gradient = svg.append("svg:defs")
            .append("svg:linearGradient")
            .attr("id", "gradient")
            .attr("x1", "0%")
            .attr("y1", "0%")
            .attr("x2", "100%")
            .attr("y2", "100%")
            .attr("spreadMethod", "pad");

        // Define the gradient colors
        gradient.append("svg:stop")
            .attr("offset", "0%")
            .attr("stop-color", color1)
            .attr("stop-opacity", 1);

        gradient.append("svg:stop")
            .attr("offset", "100%")
            .attr("stop-color", color2)
            .attr("stop-opacity", 1);
    }
    const drawText = (label, x, y, state, isUnplanned) => {
        let text = svg.append('text')
            .attr("x", x)
            .attr("y", y + 2.5)
            .attr('text-anchor', 'middle')
            .text(function (d) {
                return label;
            })
            .attr('class', 'node')
            .on("click", onClickHandler)
            .on("touchstart", onClickHandler)
            .on("mouseover", onMouseHandler)
            .on("mouseout", hidePopup)
            .attr("font-family", "sans-serif")
            .attr("font-weight", "bold")
            .attr("font-size", "12px");
        if (state == 'NOT_STARTED')
            text.attr("fill", "#005A70");
        else if (state == 'INSPECTION')
            text.attr("fill", "#003057");
        else
            text.attr("fill", "#fff");
        if (isUnplanned) {
            text.attr("fill", "#000000");
        }
    }
    const drawCircle = (radius, centerX, centerY, state, label) => {
        let isUnplanned = false;
        let labelDetail = "";
        let color;
        let shape;
        let textAchor = svg.append("a")
            .on("mouseover", onMouseHandler)
            .on("mouseout", onMouseOutHandler)
            .on("focus",onMouseHandler)
            .on("blur",onMouseOutHandler)
            .on("click", onClickHandler)
            .on("touchstart", onClickHandler)
            .attr("href", "javascript:void(0)")
            .attr("class", "textAchor ui button")
            .attr("data-position", "bottom center")
            .attr('role', 'button');//rk   
        if (label == "A") {
            // let p = document.createElement("p");
            // let ptxt = document.createTextNode("Hello World");
            // p.appendChild(ptxt);
            // textAchor.append(() => p);  // Append the p element

        }
        if (state == "INSPECTION") {
            centerX = centerX - 15;
            centerY = centerY - 15;
            shape = textAchor.append('polygon') //.on("mouseover", onMouseHandler).on("click", onClickHandler)
                .attr('points', (centerX + 15) + ',' + centerY + ' ' + (centerX + 30) + ',' + (centerY + 15) + ' ' + (centerX + 15) + ',' + (centerY + 30) + ' ' + centerX + ',' + (centerY + 15))
                .attr('stroke', 'black')
                .attr('stroke-width', '1')
                .attr('class', 'node')
                .attr('fill', '#EA7600');
        } else {
            shape = textAchor.append('circle') //.on("mouseover", onMouseHandler).on("click", onClickHandler)
                .attr('cx', centerX)
                .attr('cy', centerY)
                .attr('r', radius)
                .attr('class', 'node')
                .attr('fill', '#80ccff');
        }
        // .attr('tabindex',-1)
        //.attr('role','application'); //rk
        let selectedNode = uiDataObject?.laststate?.tasks[getAlphabetIndex(label)];
        let labelStartText = "Early Start " + selectedNode?.earlyStart + " Duration " +
            selectedNode?.actualTime + " Early Finish" + selectedNode?.earlyFinish;
        let labelEndText = "Start " + selectedNode?.lateStart + " Slack " + selectedNode?.slackTime +
            " Late Finish" + selectedNode?.lateFinish;
        if (state == 'NOT_STARTED') {
            labelDetail = "Not started task " + label;
            shape.attr('stroke', '#000000')
                .attr('stroke-width', 1)
                .attr('fill', '#D4EAE4');
        } else if (state == 'IN_PROGRESS') {
            labelDetail = "In progress task " + label;
            shape.attr('stroke', '#000000')
            let animation = shape.append('animate')
                .attr('attributeType', 'XML')
                .attr('attributeName', 'fill')
                .attr('values', '#12B2A6;#D4EAE4;#12B2A6;#12B2A6')
                .attr('dur', '1.5s')
                .attr('repeatCount', 'indefinite');
        } else {
            if (state == 'COMPLETED') {
                shape.attr('stroke', '#000000')
                labelDetail = "Completed task " + label;
                color = '#008638';
            }
            else {
                labelDetail = "Inspection task " + label;
                color = '#EA7600';
            }
            shape.attr('fill', color);

            //getGradient(color, 'white');
        }
        //textAchor.attr('role','link');
        // textAchor.attr('aria-label',labelDetail);
        let currentId = "labelDetail" + selectedNode;
        textAchor.attr('aria-labelledby', "labelDetails");

        /*Adding unplanned style to all the task nodes which are not planned on when stage=0*/
        if (uiDataObject.currentstep == 1) {
            let item = uiDataObject?.actions?.projectPlanOptions[getAlphabetIndex(label)];
            if (!item.optionsUpdated && ['C', 'L', 'Z'].indexOf(item.taskId) < 0) {
                isUnplanned = true;
                shape.attr('stroke', '#000000')
                    .attr('stroke-width', 1)
                    .attr('fill', '#FFFFFF');
            }
        }
        shape.append('text').text(function (d) {
            return label;
        });
        if (state == "INSPECTION") {
            centerX = centerX + 15
            centerY = centerY + 15;
            drawText(label, centerX - .5, centerY + 1.5, state, isUnplanned);
        } else {
            drawText(label, centerX - .5, centerY + 1.5, state, isUnplanned);
        }
        //drawText(label, centerX, centerY, state);

    }
    const getStateByTask = (label) => {

        let state = 'NOT_STARTED';
        if (["C", "L", "Z"].indexOf(label) >= 0) {
            state = 'INSPECTION';
        } else {
            uiDataObject?.laststate?.tasks.forEach(function (task, index) {
                if (task.taskId == label) {
                    state = task.currentState;
                }
            });
        }
        return state;
    }
    const isInProgress = (label) => {
        let result = false;
        uiDataObject?.laststate?.tasks.forEach(function (task, index) {
            if (task.taskId == label && task.currentState == "IN_PROGRESS") {
                result = true;
            }
        });
        return result;
    }
    const getNextNodes = (currentNode) => {
        let nextNodes = [];
        nextNodes = getPreceedingNodes(currentNode.v);
        let index = 0;
        nextNodes.forEach(function (item) {
            let prevNodes = [];
            prevNodes = getPreviousNodes(item.v);
            let allPreviousPlotted = true;
            let greatestX = currentNode.x;
            let greatestY = currentNode.y;
            let leastY = currentNode.y;
            let node = item;
            node.x = currentNode.x + 46;
            if (prevNodes.length > 2) {
                prevNodes.forEach(function (prevNode) {
                    if (prevNode.u == item.u && prevNode.v == item.v)
                        prevNode.y = currentNode.y;
                    allPreviousPlotted = allPreviousPlotted && (prevNode.x != undefined) && (prevNode.y != undefined);
                    greatestX = prevNode.x && greatestX < prevNode.x ? prevNode.x : greatestX;
                    greatestY = prevNode.y && greatestY < prevNode.y ? prevNode.y : greatestY;
                    leastY = prevNode.y && leastY > prevNode.y ? prevNode.y : leastY;
                });
                if (allPreviousPlotted) {
                    node.x = greatestX;
                    node.y = prevNodes.length <= 2 ? currentNode.y : leastY + (greatestY - leastY - 17) / 2;
                } else
                    node.y = currentNode.y;
            } else {
                node.y = nextNodes.length <= 2 ? currentNode.y : currentNode.y - (17 * nextNodes.length) + (50) * index;
            }
            node.state = getStateByTask(node.v);
            index++;
        });
        return nextNodes;
    }
    const getPreceedingNodes = (currentNode) => {
        let nextNodes = [];
        nodes2.forEach(function (item) {
            if (item.u == currentNode)
                nextNodes.push(item);
        });
        return nextNodes;
    }
    const getPreviousNodes = (currentNode) => {
        let prevNodes = [];
        nodes2.forEach(function (item) {
            if (item.v == currentNode)
                prevNodes.push(item);
        });
        return prevNodes;
    }
    const drawLine = (x1, y1, x2, y2, color, width, isArrowHeadRequired, state) => {
        let line = svg.append('line')
            .attr('x1', x1)
            .attr('y1', y1)
            .attr('x2', x2)
            .attr('y2', y2)
            .attr('stroke', color)
            .attr('stroke-width', width)
            .attr('stroke-dasharray', state != 'COMPLETED' ? `3, 3` : `0, 0`)
            .attr('aria-hidden', true);
        if (isArrowHeadRequired) {
            if (color == "#DB0020") {
                line.attr('marker-end', 'url(#red_arrow)');
            } else {
                line.attr('marker-end', 'url(#grey_arrow)');
            }
        }
    }
    const drawConnector = (x1, y1, x2, y2, isCritical, state) => {
        let color = (isCritical) ? '#DB0020' : '#000000';
        let width = (isCritical) ? 2 : 1;
        if (x2 - x1 > 50) {
            let tempx1 = x1 + radius;
            let tempx2 = x2 - 30;
            drawLine(tempx1, y1, tempx2, y1, color, width, false, state);
            x1 = x2 - (30 + radius);
        }
        if (x2 - radius < x1 + radius) {
            drawLine((x1 + x2) / 2, y1 + radius, (x1 + x2) / 2, y2 - radius, color, width, true, state);
        } else {
            drawLine(x1 + radius, y1, x2 - radius, y2, color, width, true, state);
        }

    }
    const isCriticalPathNode = (prev, current) => {
        let result;
        if (copyUiDataObject?.laststate?.criticalPath) {
            let criticalPaths = copyUiDataObject?.laststate?.criticalPath.split(',');
            result = false;
            criticalPaths?.forEach(function (critialPath) {
                let str = prev + current;
                result = result || critialPath.search(str) >= 0;
            });
        }
        return result;
    }
    const initiateGraph = () => {
        let aonSvg = document.getElementById('aonSvg');
        let defs = aonSvg.querySelector('defs');
        let title = aonSvg.querySelector('#svgTitle');
        let desc = aonSvg.querySelector('#svgDesc');
        while (aonSvg.firstChild) {
            aonSvg.removeChild(aonSvg.firstChild);
        }
        defs != null && aonSvg.appendChild(defs);
        title != null && aonSvg.appendChild(title);
        desc != null && aonSvg.appendChild(desc);
        nodes2 = Array.from(JSON.parse(JSON.stringify(graphValues.graphdata.links)));
        let id = -1;
        let nodesToPlot = [];
        let leftOverNodes = [];
        let pushedLeftOverNodes = [];
        let nodesPlotted = [];
        let startNode = {};
        startNode.u = '-';
        startNode.v = 'A';
        startNode.x = 20;
        startNode.y = 85;
        startNode.state = getStateByTask(startNode.v);
        nodesToPlot.push(startNode);
        while (true) {
            if (nodesToPlot.length == 0) {
                if (leftOverNodes.length > 0) {
                    leftOverNodes.forEach(function (itemToPush) {
                        nodesToPlot.push(itemToPush);
                        pushedLeftOverNodes.push(itemToPush);
                    });
                    leftOverNodes = [];
                } else {
                    break;
                }
            } else {
                let item = nodesToPlot[nodesToPlot.length - 1];
                let isAlreadyPlotted = false;
                let alreadyPlottedNode;
                nodesPlotted.forEach(function (plottedNode) {
                    if (plottedNode.label == item.v) {
                        alreadyPlottedNode = plottedNode;
                        isAlreadyPlotted = true;
                    }
                });
                if (!isAlreadyPlotted) {
                    let aleadyLeftOver = false;
                    pushedLeftOverNodes.forEach(function (leftNode) {
                        if (item.v == leftNode.v && item.u == leftNode.u)
                            aleadyLeftOver = true;
                    });
                    let preceedingNodes = getPreviousNodes(item.v);
                    if (preceedingNodes.length > 2 && !aleadyLeftOver) {
                        leftOverNodes.push(item);
                        nodesToPlot.pop();
                    } else {
                        if (nodesPlotted) {
                            let previous;
                            nodesPlotted.forEach(function (plottedNode) {
                                if (plottedNode.label == item.u)
                                    previous = plottedNode;
                            });
                            if (previous) {
                                //let isCriticalPath= (scope.previous.label+item.v)      
                                if (item.state == "INSPECTION") {
                                    drawConnector(previous.x, previous.y, item.x, item.y, isCriticalPathNode(previous.label, item.v), getStateByTask(item.u));
                                } else {
                                    drawConnector(previous.x, previous.y, item.x, item.y, isCriticalPathNode(previous.label, item.v), item.state);
                                }

                            }
                        }
                        drawCircle(radius, item.x, item.y, item.state, item.v);
                        nodesPlotted.push({
                            'label': item.v,
                            'x': item.x,
                            'y': item.y
                        });
                        nodesToPlot.pop();
                        let nextNodes = getNextNodes(item);
                        nextNodes.forEach(function (itemToPush) {
                            nodesToPlot.push(itemToPush);
                        });
                    }
                } else {
                    let previous;
                    nodesPlotted.forEach(function (plottedNode) {
                        if (plottedNode.label == item.u)
                            previous = plottedNode;
                    });
                    if (item.state == "INSPECTION") {
                        drawConnector(previous.x, previous.y, alreadyPlottedNode.x, alreadyPlottedNode.y, isCriticalPathNode(previous.label, alreadyPlottedNode.label), getStateByTask(item.u));
                    } else {
                        drawConnector(previous.x, previous.y, alreadyPlottedNode.x, alreadyPlottedNode.y, isCriticalPathNode(previous.label, alreadyPlottedNode.label), getStateByTask(alreadyPlottedNode.label));
                    }
                    nodesToPlot.pop();
                }
            }
        }
    }
    const createTooltip = (text) => {
        let selectedNode = uiDataObject?.laststate?.tasks[getAlphabetIndex(text)];
        const statusMap = { 'COMPLETED': 'Completed task', 'IN_PROGRESS': 'In progress task', 'NOT_STARTED': 'Not started task' };
        let nodeStatus = statusMap[selectedNode?.currentState] ?? 'Inspection task';
        let html = "";
        html += '<div id="labelDetails" class="label-details">' +
            '<div>' +
            '<span>Early Start <br aria-hidden="true" role="presentation" />' + selectedNode.earlyStart + '</span>' +
            '<span>Duration <br aria-hidden="true" role="presentation"/>' + selectedNode.actualTime + '</span>' +
            '<span>Early Finish <br aria-hidden="true" role="presentation"/>' + selectedNode.earlyFinish + '</span>' +
            '</div>' +
            '<div>' +
            '<span class="screenHidden">' + nodeStatus + '</span><span class="task_name">' + text + ": " + window.graphdata.names[getAlphabetIndex(text)] + '</span>' +
            '</div>' +
            '<div>' +
            '<span>Late Start <br aria-hidden="true" role="presentation"/>' + selectedNode.lateStart + '</span>' +
            '<span>Slack <br aria-hidden="true" role="presentation"/>' + selectedNode.slackTime + '</span>' +
            '<span>Late Finish <br aria-hidden="true" role="presentation"/>' + selectedNode.lateFinish + '</span>' +
            '</div>' +
            '<div>';
        return html;
    }
    const showToolTip = (currentTarget, position, text) => {
        let tooltip = document.getElementById('graph_tooltip');
        if (tooltip) {
            let top = (position.top - document.getElementById("aon_container").getBoundingClientRect().top) - 120;
            let left = (position.left - document.getElementById("aon_container").getBoundingClientRect().left) - 113;
            let bottom = (position.top - document.getElementById("aon_container").getBoundingClientRect().top) + 25
            // let right = left + tooltip.clientWidth
            tooltip.removeAttribute("style")
            tooltip.classList.remove("bottom");
            tooltip.classList.remove("left");
            tooltip.classList.remove("right")
            tooltip.classList.add("top");
            tooltip.classList.add("center");

            if (((left + window.$(tooltip).width()) > document.getElementById("aon_container").clientWidth) || (top + window.$(tooltip).height()) > document.getElementById("aon_container").clientHeight) {
                tooltip.classList.remove("top");
                tooltip.classList.add("left");
                left = left - 148
                top = top + 78
            }
            else if (left < 0) {
                tooltip.classList.remove("top");
                tooltip.classList.add("right");
                left = left + 140
                top = top + 78
            }
            else if (top < 0 && left > 0) {
                tooltip.classList.remove("top");
                tooltip.classList.add("bottom");
                top = bottom
            }

            // tooltip.setAttribute("style","");
            tooltip.style.left = left + "px"; //("left", left);
            tooltip.style.top = top + "px";//css("top", top);
            tooltip.innerHTML = createTooltip(text);
            tooltip.style.display = 'block';
        }
    }
    const updateTaskOptions = (selectedOptionType) => {
        setOvertimeData({
            "cost": selectedTask[selectedOptionType?.toLowerCase() + "OptionOverTimeCost"],
            "days": selectedTask[selectedOptionType?.toLowerCase() + "OverTimeDays"],
        });
        setSupplierData({
            "cost": selectedTask['localSupplierCost'],
            "days": selectedTask['localSupplierDays'],
            "suppilerName": selectedTask['localSuppilerOptionName'],
        })
    }
    const calculateProjectParams = () => {
        if(copyUiDataObject?.actions?.projectPlanOptions && copyUiDataObject?.laststate?.tasks && copyUiDataObject?.laststate?.criticalPath){
            let prevProjectedCompletionTime = simObj?.laststate?.projectedCompletionTime
            let prevProjectedProjectCost = 0
            let criticalPath = copyUiDataObject?.laststate?.criticalPath.split(',')[0]
            copyUiDataObject?.actions?.projectPlanOptions?.forEach(function (item) {
                let simObjProjectPlanOption = simObj?.actions?.projectPlanOptions?.find((plan)=>plan?.taskId == item?.taskId);
                let simObjSelectedTaskOption = simObjProjectPlanOption?.pmTaskOptions?.find((a)=>a.optionType == simObjProjectPlanOption?.selectedOptionType)
                let itemSelectedTaskOption = item?.pmTaskOptions?.find((a)=>a.optionType == item?.selectedOptionType)
                if((item?.selectedOptionType != simObjProjectPlanOption?.selectedOptionType) || (simObjSelectedTaskOption.overTimeSelected != itemSelectedTaskOption?.overTimeSelected) || (itemSelectedTaskOption?.localSupplierSelected != simObjSelectedTaskOption?.localSupplierSelected) || (simObj?.currentstep == 1 && (simObjProjectPlanOption?.selectedOptionType != "CHEAPER" || simObjSelectedTaskOption.overTimeSelected || itemSelectedTaskOption?.localSupplierSelected))){
                    if(simObj?.currentstep == 1 && (simObjProjectPlanOption?.selectedOptionType != "CHEAPER" || simObjSelectedTaskOption.overTimeSelected || itemSelectedTaskOption?.localSupplierSelected)){
                        let simObjProjectPlanCheaperOption = simObjProjectPlanOption?.pmTaskOptions?.find((a)=>a.optionType == "CHEAPER")
                        if(simObjProjectPlanCheaperOption){
                            if (criticalPath.indexOf(simObjProjectPlanOption.taskId) >= 0){
                                prevProjectedCompletionTime -= simObjProjectPlanCheaperOption?.days
                                prevProjectedCompletionTime += itemSelectedTaskOption?.days
                                if(itemSelectedTaskOption?.overTimeSelected){
                                    prevProjectedCompletionTime -= item[item.selectedOptionType.toLowerCase() + "OverTimeDays"]
                                }
                                if(itemSelectedTaskOption?.localSupplierSelected){
                                    prevProjectedCompletionTime -= item.localSupplierDays
                                }
                            } 
                        } 
                    }
                    else{
                        if (criticalPath.indexOf(simObjProjectPlanOption.taskId) >= 0){
                            prevProjectedCompletionTime -= simObjSelectedTaskOption?.days
                            if(simObjSelectedTaskOption?.overTimeSelected){
                                prevProjectedCompletionTime += simObjProjectPlanOption[simObjProjectPlanOption.selectedOptionType.toLowerCase() + "OverTimeDays"]
                            }
                            if(simObjSelectedTaskOption?.localSupplierSelected){
                                prevProjectedCompletionTime += simObjProjectPlanOption.localSupplierDays
                            }
                            prevProjectedCompletionTime += itemSelectedTaskOption?.days
                            if(itemSelectedTaskOption?.overTimeSelected){
                                prevProjectedCompletionTime -= item[item.selectedOptionType.toLowerCase() + "OverTimeDays"]
                            }
                            if(itemSelectedTaskOption?.localSupplierSelected){
                                prevProjectedCompletionTime -= item.localSupplierDays
                            }
                        }
                    }
                }
                prevProjectedProjectCost += itemSelectedTaskOption?.cost
                if(itemSelectedTaskOption?.overTimeSelected){
                    prevProjectedProjectCost += item[item.selectedOptionType.toLowerCase() + "OptionOverTimeCost"];
                }
                if(itemSelectedTaskOption?.localSupplierSelected){
                    prevProjectedProjectCost += item?.localSupplierCost
                }
            });

            let projectDelay = prevProjectedCompletionTime - copyUiDataObject?.deadlinedays;
            let projectStatus = 'On Schedule';
            if (projectDelay < 0) {
                projectStatus = 'Ahead of Schedule';
            } else if (projectDelay > 0) {
                projectStatus = 'Delayed';
            }
            else{
                projectStatus = 'On Schedule';
            }

            let costParameters = {
                projectedCompletionTime : prevProjectedCompletionTime,
                projectCost: prevProjectedProjectCost,
                projectDelay: (projectDelay > 0) ? 
                                Math.abs(projectDelay) + ' days over time ' : 
                                (projectDelay === 0) ? 'On time ' :
                                Math.abs(isNaN(projectDelay) ? 0 : projectDelay) + ' days ahead of time ',
                projectStatus: projectStatus,
                projectProfit : isNaN(simObj?.laststate?.constructionBudget - prevProjectedProjectCost) ? 0 : simObj?.laststate?.constructionBudget - prevProjectedProjectCost,
                profitPercentage: isNaN(Number(Math.abs(((simObj?.laststate?.constructionBudget - prevProjectedProjectCost) / simObj?.laststate?.constructionBudget) * 100).toFixed(2))) ? 0 : Number(((simObj?.laststate?.constructionBudget - prevProjectedProjectCost) / simObj?.laststate?.constructionBudget) * 100).toFixed(2)
            }
            setCostParameters((prevParams)=>({
                ...prevParams,
                ...costParameters
            }))
            // console.log(costParameters)
            // costParameters = [{
            //     label: 'Projected Project Cost',
            //     value: isNaN(prevProjectedProjectCost) ? 0 : prevProjectedProjectCost,
            //     projectProfit: isNaN(simObj?.laststate?.constructionBudget - prevProjectedProjectCost) ? 0 : simObj?.laststate?.constructionBudget - prevProjectedProjectCost,
            //     profitPercentage: isNaN(Number(Math.abs(((simObj?.laststate?.constructionBudget - prevProjectedProjectCost) / simObj?.laststate?.constructionBudget) * 100).toFixed(2))) ? 0 : Number(((simObj?.laststate?.constructionBudget - prevProjectedProjectCost) / simObj?.laststate?.constructionBudget) * 100).toFixed(2)
            //     // status: Math.abs(simObj?.laststate?.constructionBudget - totalCost),
            //     // css: (simObj?.laststate?.constructionBudget - totalCost >= 0) ? 'less' : 'over',
            // }, {
            //     label: 'Projected Completion',
            //     value: isNaN(prevProjectedCompletionTime) ? 0 : prevProjectedCompletionTime,
            //     status: (projectDelay > 0) ? 
            //     Math.abs(projectDelay) + ' days over time' : 
            //     (projectDelay === 0) ? 'On time' :
            //     Math.abs(isNaN(projectDelay) ? 0 : projectDelay) + ' days ahead of time'
            //     ,
            //     // css: (projectDelay >= 0) ? 'over' : 'less',
            // }, {
            //     label: 'Project Status',
            //     value: projectStatus,
            //     // css: projectStatus.toLowerCase(),
            // }]
            // setUiDataObject((prevUiDataObject)=>({
            //      ...prevUiDataObject,
            //      ['costParameters']: costParameters
            // }))
            // debugger;
            // setCostParameters(costParameters);
        }
        calculateCriticalPath();
    }
    const calculateCriticalPath = () => {
        // debugger;
        let allTaskTimes = [];
        let totalTimeArray = [];
        let criticalPathObj = [];
        graphValues?.graphdata?.criticalPaths?.forEach(function (path) {
            let totalTime = 0;
            let arrPath = path.split(''),
                tasksTime = 0;
            arrPath.forEach(function (str) {
                let item = copyUiDataObject?.actions?.projectPlanOptions[getAlphabetIndex(str)];
                item?.pmTaskOptions.forEach(function (obj) {
                    if (obj.optionType == item.selectedOptionType) {
                        tasksTime = 0;
                        if (item.taskState == "NOT_STARTED") {
                            tasksTime += obj.days;
                        } else {
                            tasksTime += uiDataObject?.laststate?.tasks[getAlphabetIndex(item.taskId)].actualTime;
                        }
                        if (obj.overTimeSelected) {
                            if (item.overTimeOptionAvailable) {
                                tasksTime -= item[item.selectedOptionType.toLowerCase() + "OverTimeDays"];
                            }
                        }
                        if (obj.localSupplierSelected) {
                            if (item.localSupplierOptionAvailable) {
                                tasksTime -= item.localSupplierDays;
                            }
                        }
                        if (tasksTime < 0) {
                            tasksTime = 0;
                        }
                        totalTime += tasksTime;
                    }
                });
            });
            totalTimeArray.push(totalTime + uiDataObject?.laststate?.randomEventDays);
            criticalPathObj.push({
                path: path,
                time: totalTime + uiDataObject?.laststate?.randomEventDays
            });
        });
        criticalPathObj.sort(function (a, b) {
            return a.time - b.time;
        });

        let arr = []
        let criticalPathList = []
        // for (let i = criticalPathObj.length - 1; i >= 0; i--) {
        //     arr.push(criticalPathObj[i].path);
        //     if (criticalPathObj[i].time != criticalPathObj[i - 1].time) {
        //         break;
        //     }
        // }
        let possibleCriticalPaths = criticalPathObj
        let longestTime = possibleCriticalPaths[0].time

        for (let i = 1; i < possibleCriticalPaths.length; i++) {
            const pathTime = possibleCriticalPaths[i].time
            if (pathTime > longestTime) {
                longestTime = pathTime;
            }
        }

        for (let i = 0; i < possibleCriticalPaths.length; i++) {
            const pathTime = possibleCriticalPaths[i].time
            if (pathTime === longestTime) {
                criticalPathList.push(possibleCriticalPaths[i].path);
            }
        }

        for (let i = 0; i < criticalPathList.length; i++) {
            if (!arr.includes(criticalPathList[i])) {
                if (i === criticalPathList.length - 1) {
                    arr.push(criticalPathList[i]);
                } else {
                    arr.push(criticalPathList[i]);
                }
            }
        }

        if (uiDataObject?.laststate != undefined && uiDataObject?.laststate?.criticalPath != arr.join(',')) {
            // uiDataObject.laststate.criticalPath = arr.join(','); // need to update laststate with critical path
            setUiDataObject((prevDataObj) => ({
                ...prevDataObj,
                ['laststate']: {
                    ...prevDataObj?.laststate,
                    ['criticalPath']: arr.join(',')
                }
            }))
        }

        if (copyUiDataObject?.laststate != undefined && copyUiDataObject?.laststate?.criticalPath != arr.join(',')) {
                setCopyUiDataObject((prevDataObj) => ({
                    ...prevDataObj,
                    ['laststate']: {
                        ...prevDataObj?.laststate,
                        ['criticalPath']: arr.join(',')
                    }
                }))
        }
    }
    // useEffect(()=>{
    //     setTimeout(() => {
    //         setCostParameters(costParameters)
    //     }, 100);
    // },[copyUiDataObject?.actions?.projectPlanOptions,uiDataObject?.laststate?.criticalPath])
    const selectTask = (taskIndex) => {
        setSelectedTaskIndex(taskIndex);
        setOriginalSelectedTask(JSON.parse(JSON.stringify(uiDataObject?.actions?.projectPlanOptions[taskIndex])));
        setSelectedTask(uiDataObject?.actions?.projectPlanOptions[taskIndex])
        // let selectedTask = Object.keys(selectedTask).length == 0 && uiDataObject?.actions?.projectPlanOptions[taskIndex];
        if (selectedTask?.pmTaskOptions?.length == 3 || uiDataObject?.actions?.projectPlanOptions[taskIndex]?.pmTaskOptions?.length == 3) {
            setSelectedRadioIndex(1)
        } else {
            setSelectedRadioIndex(0)
        }
        updateTaskOptions(uiDataObject?.actions?.projectPlanOptions[taskIndex]?.selectedOptionType);
    }
    // const getKeyByValue = (object, value) => {
    //     for (const key in object) {
    //       if (object.hasOwnProperty(key)) {
    //         if (object[key] === value) {
    //           return key;
    //         }
    //       }
    //     }
    //     return null; // Return null if the value is not found
    //   }
    function getKeysByValue(object, value) {
        const keys = [];
        for (const key in object) {
          if (object.hasOwnProperty(key)) {
            if (object[key] === value) {
              keys.push(key);
            }
          }
        }
        return keys.length > 0 ? keys : null; // Return null if the value is not found
      }
    useEffect(()=>{
        if(selectedTaskIndex && (Object.keys(selectedDependentTask).length == 0) && Object.values(dependentTasks).includes(uiDataObject?.actions?.projectPlanOptions[selectedTaskIndex].taskId)){
            // debugger;
            let selectedDependentTaskIndex1 = []
            let index = getKeysByValue(dependentTasks,uiDataObject?.actions?.projectPlanOptions[selectedTaskIndex].taskId)
            for (const i in index) {
                selectedDependentTaskIndex1.push(getAlphabetIndex(index[i]))
            }
            setSelectedDependentTaskIndex(selectedDependentTaskIndex1)
            let selectedDependentTasks = [];
            for (const i in selectedDependentTaskIndex1) {
                // selectedDependentTasks.push(uiDataObject?.actions?.projectPlanOptions[selectedDependentTaskIndex1[i]])
                selectedDependentTasks.push(JSON.parse(JSON.stringify(uiDataObject?.actions?.projectPlanOptions[selectedDependentTaskIndex1[i]])))
            }
            setSelectedDependentTask(selectedDependentTasks)
        }
    },[selectedTaskIndex,showTaskSelectionPopup])

    const handleTaskSelect = (position, task) => {
        setIsTaskOptionChanged(false);
        //    setToggleSimulation(false);
        setShowTaskSelectionPopup(true);
        // window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({"aria-hidden":"true"});
        // if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
        //     window.$(".task-selector").find(".person-description").removeAttr("aria-hidden tabindex");
        // }
        let taskIndex = getAlphabetIndex(task);
        selectTask(taskIndex);
        window.$('.ui.modal')
            .modal({
                onApprove: function (event) {
                    alert("approve");
                },
                onVisible : ()=>{
                    // calculateProjectParams();
                },
                onHidden : ()=>{
                    // calculateProjectParams();
                }
            })
        window.$(".task-selector-bg.modal").length > 1 && window.$(".task-selector-bg.modal:first-child").remove()
        // window.$(".task-selector-bg.modal").html("");
        window.$(".task-selector-bg.modal").attr("task", task).modal("show");
        setToggleSimulation(false);
        //window.$(".save_tasks").addClass("disabled").attr("disabled",'disabled');
    }
    const onHandleSaveTask = () => {
        // debugger;
        let a = {...selectedDependentTask}
        for (const i in a) {
            a[i]['optionsUpdated'] = true;
        }
        setSelectedDependentTask(a);

        let taskId = selectedTask?.taskId;
        isSave.current = true;
        setUiDataObject((prevDataObj) => ({
            ...prevDataObj,
            ['actions']: {
                ...prevDataObj?.actions,
                ['taskOptions']: (prevDataObj?.actions?.taskOptions != null) ? [...prevDataObj?.actions?.taskOptions?.map((option) => {
                    return (taskId == option.taskId) ? { ...selectedTask } : { ...option }
                }), ...(taskId && !prevDataObj?.actions?.taskOptions?.some(option => option.taskId === taskId)) ? [{ ...selectedTask,['optionsUpdated']: uiDataObject.currentstep == 1 ? true : undefined }] : []] : [{ ...selectedTask }],
                ['projectPlanOptions']: [...prevDataObj?.actions?.projectPlanOptions?.map((option) => {
                    // return (taskId == option.taskId) ? { ...selectedTask, ['optionsUpdated']: uiDataObject.currentstep == 1 ? true : undefined } : { ...option }
                    return (taskId == option.taskId) ? { ...selectedTask, ['optionsUpdated']: true } : { ...option }
                })]
            }
        }));
        updateTaskProperties();
        calculateProjectParams();
        let allnode = window.$(".textAchor");
        for (let i = 0; i < allnode.length; i++) {
            let innerTextOfNode = allnode[i].getElementsByTagName("text")[0].innerHTML || allnode[i].getElementsByTagName("text")[0].textContent;
            if (innerTextOfNode == originalSelectedTask.taskId) {
                window.$(allnode[i]).focus();
                break;
            }
        }
        if (uiDataObject?.actions?.projectPlanOptions[selectedTaskIndex]) {
            uiDataObject.actions.projectPlanOptions[selectedTaskIndex] = JSON.parse(JSON.stringify(selectedTask));
        }
        setShowTaskSelectionPopup(false)
        window.$(".task-selector-bg.modal[task='" + taskId + "']").modal("hide");
        setTimeout(() => {
            focusPopUp()
        }, 1000);
        window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({ "aria-hidden": "false" });
        // setTimeout(() => {
        //     isSave.current = false;
        // }, 1000);
    }
    const onHandleSelectTaskOption = (task) => {
        setSelectedTask((prevTask) => ({
            ...prevTask,
            ['selectedOptionType']: task.optionType
        }))
        let a = {...selectedDependentTask}
        for (const i in a) {
            a[i].selectedOptionType = task.optionType
            a[i]['optionsUpdated'] = true;
            for (const j in a[i].pmTaskOptions) {
                if (a[i].pmTaskOptions[j].optionType == task.optionType) {
                    a[i].pmTaskOptions[j].localSupplierSelected = false
                    a[i].pmTaskOptions[j].overTimeSelected = false   
                }
            }
        }
        setSelectedDependentTask(a);
        updateTaskOptions(task.optionType);
        calculateProjectParams();
        onHandleDeselectOther();
    }
    const onHandleDeselectOther = (task, name) => {
        calculateProjectParams()
        // need to update using map method forEach loop do not udpate current data
        // selectedTask?.pmTaskOptions?.forEach(function (item) {
        //     if (item.optionType != selectedTask.selectedOptionType) {
        //         item.overTimeSelected = false;
        //     }
        // }); 
        if (task != undefined) {
            setSelectedTask((prevTask) => ({
                ...prevTask,
                ['pmTaskOptions']: [...prevTask?.pmTaskOptions?.map((task) => {
                    return (task?.optionType == selectedTask?.selectedOptionType) ? { ...task, [name == 'overtime' ? 'overTimeSelected' : 'localSupplierSelected']: false } : { ...task }
                })]
            }));
        } else {
            setSelectedTask((prevTask) => ({
                ...prevTask,
                ['pmTaskOptions']: [...prevTask?.pmTaskOptions?.map((task) => {
                    return (task?.optionType != selectedTask?.selectedOptionType) ? { ...task, 'overTimeSelected': false, 'localSupplierSelected': false } : { ...task }
                })]
            }));
        }
    }
    const onHandleChange = (task, name) => {
        setSelectedTask((prevTask) => ({
            ...prevTask,
            ['pmTaskOptions']: [...prevTask?.pmTaskOptions?.map((task) => {
                return (task?.optionType == selectedTask?.selectedOptionType) ? { ...task, [name == 'overtime' ? 'overTimeSelected' : 'localSupplierSelected']: true } : { ...task }
            })]
        }));
    }
    const updateTaskProperties = () => {
        if (uiDataObject.currentstep == 1) {
            setSelectedTask((prvTask) => (
                {
                    ...prvTask,
                    ['optionsUpdated']: true
                }
            ))
        }
        let optionTypes = ['CHEAPER', 'STANDARD', 'EXPENSIVE'];
        let selectedType = optionTypes.indexOf(selectedTask.selectedOptionType);
        let selectedTaskOption = selectedTask?.pmTaskOptions[selectedType]
        let localSupplierDays = 0,
            overTimeDays = 0;
        if (selectedTaskOption.localSupplierSelected) {
            localSupplierDays = selectedTask.localSupplierDays;
        }
        if (selectedTaskOption.overTimeSelected) {
            overTimeDays = selectedTask[selectedTask.selectedOptionType.toLowerCase() + "OverTimeDays"];
        }
        let taskArray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let tasks = uiDataObject?.laststate?.tasks;
        let currentTask = tasks[getAlphabetIndex(selectedTask.taskId)];
        currentTask.actualTime = selectedTaskOption.days - (localSupplierDays + overTimeDays);
        let arr = [];
        for (let i = 0; i < taskArray.length; i++) {
            let task = tasks[i];
            if (i == 0) {
                task.earlyStart = 0;
            } else {
                let previousTasks = getPreviousNodes(task.taskId);
                // task.earlyStart = getGreatestEarlyFinish(previousTasks, tasks);
            }
            task.earlyFinish = task.earlyStart + task.actualTime;
        }
        for (let i = taskArray.length - 1; i >= 0; i--) {
            let task = tasks[i];
            if (i == taskArray.length - 1) {
                task.lateFinish = task.earlyFinish;
            } else {
                let followingTasks = getPreceedingNodes(task.taskId);
                // task.lateFinish = getLowestLateStart(followingTasks, tasks);
            }
            task.lateStart = task.lateFinish - task.actualTime;
            task.slackTime = task.lateStart - task.earlyStart;
        }
        // Checking if all tasks have been updated/saved by the  user                
        if (uiDataObject.currentstep == 1) {
            const allTasksUpdated = (function () {
                for (let i in uiDataObject?.actions?.projectPlanOptions) {
                    let item = uiDataObject?.actions?.projectPlanOptions[i];
                    if (!item.optionsUpdated && ['C', 'L', 'Z'].indexOf(item.taskId) < 0) {
                        return false;
                    }
                }
                return true;
            })();
            svg = d3.select('#aonSvg');
            initiateGraph();
        }
        // calculateTimeAndCost()=>{
        //     projectPlanOptions: scope.uiDataObject?.actions?.projectPlanOptions
        // }
    }
    const closeTaskSelectionPopup = (type) => {
        setIsTaskOptionChanged(false)
        try {
            if (type == "close") {
                isSave.current = false;
                setSelectedTask(JSON.parse(JSON.stringify(originalSelectedTask)))
                setUiDataObject((prevDataObj) => ({
                    ...prevDataObj,
                    ['actions']: {
                        ...prevDataObj?.actions,
                        ['projectPlanOptions']: [...prevDataObj?.actions?.projectPlanOptions?.map((pPlanOpt, taskIdx) => (taskIdx == selectedTaskIndex) ? { ...originalSelectedTask } : { ...pPlanOpt })]
                    }
                }))
            }
            
            if (uiDataObject?.actions?.projectPlanOptions[selectedTaskIndex]) {
                uiDataObject.actions.projectPlanOptions[selectedTaskIndex] = JSON.parse(JSON.stringify(selectedTask));
            }
            calculateProjectParams();
            setShowTaskSelectionPopup(false)
            window.$(".task-selector-bg.modal").modal("hide");
            setTimeout(() => {
                focusPopUp()
            }, 1000);
            window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({ "aria-hidden": "false" });
            setEventType("");
        }
        catch(error){

        }
        finally{
            calculateProjectParams();
            setShowTaskSelectionPopup(false)
            window.$(".task-selector-bg.modal").modal("hide");
            setTimeout(() => {
                focusPopUp()
            }, 1000);
            window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({ "aria-hidden": "false" });
            setEventType("");
        }
    }

    useEffect(()=>{
        if(!showTaskSelectionPopup){
            setTimeout(() => {
                let allnode = window.$(".textAchor");
            for (let i = 0; i < allnode.length; i++) {
                let innerTextOfNode = allnode[i].getElementsByTagName("text")[0].innerHTML || allnode[i].getElementsByTagName("text")[0].textContent;
                if (innerTextOfNode == originalSelectedTask.taskId) {
                    window.$(allnode[i]).focus();
                    break;
                }
            }
            }, 0); 
        } 
    },[showTaskSelectionPopup])
    const onClickHandler = (event) => {
        let currentTarget = event.currentTarget.classList.contains('node') ? event.currentTarget.previousSibling : event.currentTarget;
        let task = currentTarget.textContent;
        let position = currentTarget.getBoundingClientRect();
        let tooltip = document.getElementById('graph_tooltip');
        if (/Android|iPad/i.test(navigator.userAgent)) {
            handleTaskSelect(position, task);
            // if (currentTask && currentTask.task && currentTask.task == task && currentTask.attempt == 1) {
            //     window.$('#graph_tooltip').hide();
            //     handleTaskSelect(position, task);
            //     currentTask.attempt = 0;
            // } else {
            //     showToolTip(position, task);
            //     currentTask.task = task;
            //     currentTask.attempt = 1;
            // }
        } else {
            handleTaskSelect(position, task);
        }
        if (window.$('.save_tasks').length > 0 && event.type != "click") {
            window.$('.taskPopUpHeading').focus();
        }
        hidePopup();
        // document.getElementById("closePopup").addEventListener("click", function(event) {
        //     event.stopPropagation();
        //     closeTaskSelectionPopup('close');
        // });
        focusPopUp();
        event.stopPropagation();
    }
    const onMouseOutHandler = (event) => {
        hidePopup();
    }
    const onMouseHandler = (event) => {
        let currentTarget = event.currentTarget.classList.contains('node') ? event.currentTarget.previousSibling : event.currentTarget;
        let position = currentTarget.getBoundingClientRect();
        if (!/Android|iPad/i.test(navigator.userAgent)) {
            showToolTip(currentTarget, position, currentTarget.textContent);
        }
    }
    const hidePopup = () => {
        let tooltip = document.getElementById('graph_tooltip');
        if (tooltip != undefined && tooltip != null) {
            tooltip.style.display = 'none';
        }
    }
    // const resizePopup =() => window.$('.ui.popup').css('max-height', window.$(window).height());
    // window.$(window).resize(function(e){
    //     resizePopup();
    // });
    window.$(window).scroll((e) => {
        hidePopup();
    });
    window.$(document).off('click touchstart', '.textAchor').on('click touchstart', '.textAchor', (event) => {
        event.stopPropagation();
        onClickHandler(event);
    });
    window.$(document).off('keydown', '.textAchor').on('keydown', '.textAchor', (event) => {
        event.stopPropagation();
        if (event.key == "Enter") {
            setEventType(event.type)
        }
    });
    /*window.$(document).off('focus', '.taskPopUpHeading').on('focus', '.taskPopUpHeading', (event) => {
        if (eventType == "") {
            event.target.blur();
        }
    }); commented for heading focus reading as dialog*/
    window.$(document).off('click touchstart', '.ui.dimmer').on('click touchstart', '.ui.dimmer', (event) => {
        if(window.$(event.target).closest(".ui.modal.task-selector-bg") && (Array.from(window.$(event.target).closest(".ui.modal.task-selector-bg")).length > 0)){
            return ;
        }
        event.preventDefault();
        setIsTaskOptionChanged(false)
        closeTaskSelectionPopup('close');
    });
    window.$(document).off('click touchstart', '.save_tasks').on('click touchstart', '.save_tasks', (event) => {
        event.stopPropagation();
        // window.$('.ui.dimmer').trigger('click');
        setIsTaskOptionChanged(false)
        onHandleSaveTask();
    });
    window.$(document).off('click touchstart', '#task-selector .sub_contractors a div').on('click touchstart', '#task-selector .sub_contractors a div', (event) => {
        if(!(window.$(event.target).closest(".person-item")[0].classList.contains("active_item")) && selectedTask?.taskOptionAvailable && !Object.keys(dependentTasks).includes(selectedTask.taskId)){
            setIsTaskOptionChanged(true);
        }
    });
    window.$(document).off('click touchstart change', '#task-selector .work_overtime fieldset input').on('click touchstart', '#task-selector .work_overtime fieldset input', (event) => {
        setIsTaskOptionChanged(true);
    });
    window.$(".task-selector-bg.modal").off('show.bs.modal').on("show.bs.modal", function (event) {
        event.stopPropagation(); // Prevent the event from reaching the component
        //window.$(".save_tasks").addClass("disabled").attr("disabled",'disabled');
        // Your modal show code here
    });
    window.$(document).off('click touchstart', '.close-button').on('click touchstart', '.close-button', (event) => {
        event.stopPropagation();
        window.$('.ui.dimmer').trigger('click');
        setIsTaskOptionChanged(false)
        closeTaskSelectionPopup('close');
    });
    window.$(document).off('click', '.sub_contractors a').on('click', '.sub_contractors a', (event) => {
        event.stopPropagation();
        let task = JSON.parse(event.currentTarget.getAttribute("task"));
        //let isChecked = window.$(".work_overtime").find("input[type=checkbox]:checked").length > 0;
        if(!Object.keys(dependentTasks).includes(task?.taskId)){
            (!selectedTask?.taskOptionAvailable || task?.taskState == 'IN_PROGRESS') || onHandleSelectTaskOption(task);
        }
        //(isChecked) ?  window.$(".save_tasks").removeClass("disabled").removeAttr("disabled",'disabled') :  window.$(".save_tasks").addClass("disabled").attr("disabled",'disabled');
    });
    window.$(document).off('click change', '.work_overtime input[type=checkbox]').on('click change', '.work_overtime input[type=checkbox]', (event) => {
        event.stopPropagation();
        setIsTaskOptionChanged(true);
        let name = event.currentTarget.getAttribute("name");
        // let isChecked = window.$(".work_overtime").find("input[type=checkbox]:checked").length > 0;
        (event.currentTarget.checked) ? onHandleChange(selectedTask, name) : onHandleDeselectOther(selectedTask, name);
        //(isChecked) ? window.$(".save_tasks").removeClass("disabled").removeAttr("disabled",'disabled') :  window.$(".save_tasks").addClass("disabled").attr("disabled",'disabled');
    });
    useEffect(() => {
        if ((uiDataObject?.actions?.projectPlanOptions?.length - 3) == uiDataObject?.actions?.taskOptions?.length){
            setIsEnabledSimulationBtn(true);
        }
        // let copyObj = {
        //     ...uiDataObject,
        //     ['actions']: {
        //         ...uiDataObject?.actions,
        //         ['taskOptions']: (uiDataObject?.currentstep <= 1 || uiDataObject?.actions?.taskOptions != null) ? uiDataObject?.actions?.projectPlanOptions?.map((pPlanOpt) =>
        //             (pPlanOpt?.taskId == "C" || pPlanOpt?.taskId == "L" || pPlanOpt?.taskId == "Z") ? pPlanOpt?.pmTaskOptions?.filter((ptOpt) => !ptOpt?.overTimeSelected || !ptOpt?.localSupplierSelected)[0] : (pPlanOpt?.pmTaskOptions?.filter((ptOpt) => ptOpt?.overTimeSelected || ptOpt?.localSupplierSelected)).length > 0 ? { ...pPlanOpt?.pmTaskOptions?.filter((ptOpt) => ptOpt?.overTimeSelected || ptOpt?.localSupplierSelected)[0], ['optionType']: pPlanOpt.selectedOptionType, ['optionsUpdated']: pPlanOpt.optionsUpdated != undefined ? pPlanOpt.optionsUpdated : false } : { ...pPlanOpt?.pmTaskOptions?.filter((ptOpt) => ptOpt)[0], ['optionType']: pPlanOpt.selectedOptionType,['optionsUpdated']: pPlanOpt.optionsUpdated != undefined ? pPlanOpt.optionsUpdated : false}) : null //ptOpt?.overTimeSelected || ptOpt?.localSupplierSelected
        //     }
        // }

        let copyObj = {
            ...uiDataObject, // Shallow copy of uiDataObject
            ['actions']: { // Modifying the actions property
                ...uiDataObject?.actions, // Shallow copy of uiDataObject.actions
                ['taskOptions']: ( // Modifying taskOptions property based on conditions
                    uiDataObject?.currentstep <= 1 || uiDataObject?.actions?.taskOptions != null // Condition check
                    ? uiDataObject?.actions?.projectPlanOptions?.map((pPlanOpt) => // Mapping projectPlanOptions array
                        (pPlanOpt?.pmTaskOptions?.length == 1) // TaskId condition

                        ? pPlanOpt?.pmTaskOptions[0] // Filtering options

                        : { // If length is greater than 0
                            ...pPlanOpt?.pmTaskOptions?.filter((ptOpt) =>  ptOpt.optionType == pPlanOpt.selectedOptionType)[0], // Shallow copy of filtered option
                            ['optionsUpdated']: pPlanOpt.optionsUpdated != undefined ? pPlanOpt.optionsUpdated : false // Adding optionsUpdated property
                        }
                    )
                    : null // If condition fails, set to null
                )
            }
        }


        setSimObjCopy(copyObj);
        setSaveData(copyObj);
    }, [uiDataObject])
    useEffect(()=>{
        let count = 0;
        if(uiDataObject){
            for (const i in uiDataObject?.actions?.projectPlanOptions) {
                if (uiDataObject?.actions?.projectPlanOptions[i].optionsUpdated == true) {
                    count++;
                }
            }
            // if(count == 23 && uiDataObject?.actions?.taskOptions?.length==23){
            //     setIsEnabledSimulationBtn(true)
            // }
            if(count == 23 && uiDataObject?.actions?.taskOptions != null){
                setIsEnabledSimulationBtn(true)
            }
        }
    },[uiDataObject])
    // useEffect(()=>{console.log(simObjCopy)},[simObjCopy]);

    useEffect(()=>{
        let isUpdated = true;
        if(simObjCopy?.actions?.taskOptions && simObjCopy?.actions?.projectPlanOptions){
            for (const i in simObjCopy?.actions?.projectPlanOptions) {
                let taskOption = simObjCopy?.actions?.projectPlanOptions?.[i]?.pmTaskOptions?.find((option=> option.optionType == simObjCopy?.actions?.projectPlanOptions[i]?.selectedOptionType))
                if ((simObjCopy?.actions?.projectPlanOptions[i].selectedOptionType != simObjCopy?.actions?.taskOptions[i].optionType) ||
                    (simObjCopy?.actions?.taskOptions?.[i]?.localSupplierSelected != taskOption?.localSupplierSelected) ||
                    (simObjCopy?.actions?.taskOptions?.[i]?.overTimeSelected != taskOption?.overTimeSelected)
                ) {
                    isUpdated = false;
                }
            }
        }
        if(isSave.current && isUpdated){
            // if(isSave.current){
        // debugger;
            let found = false
            let dependentUpdated = false
            for(let i in dependentTasks){
                if(dependentTasks[i] == selectedTask.taskId){
                    found = true
                    // let item = simObjCopy?.actions?.taskOptions?.filter(item => item.taskId == i)[0]
                    // let selected = simObjCopy?.actions?.taskOptions?.filter(item => item.taskId == selectedTask.taskId)[0]
                    let item = simObjCopy?.actions?.taskOptions?.filter(item => item.taskId == i)[0]
                    let selected = simObjCopy?.actions?.taskOptions?.filter(item => item.taskId == selectedTask.taskId)[0]
                    if(selected?.optionType == selectedTask?.selectedOptionType && item.optionType == selected.optionType && item.localSupplierSelected == false && item.overTimeSelected == false){
                        dependentUpdated =  true
                    }
                }
            }

            if(!found || (found && dependentUpdated)){
                saveSimulation();
                // calculateProjectParams();
                isSave.current = false;
                setSelectedDependentTask({}) 
                setSelectedDependentTaskIndex('');
            }
        }
        initDependantTasks();
    },[simObjCopy?.actions?.taskOptions,isSave.current]);
    
    useEffect(() => {
        setSupplierData({
            cost: selectedTask['localSupplierCost'],
            days: selectedTask['localSupplierDays'],
            suppilerName: selectedTask['localSuppilerOptionName'],
        });
        if (copyUiDataObject?.actions?.projectPlanOptions != undefined && copyUiDataObject?.actions?.projectPlanOptions?.length != 0) {
            let copyObj = {
                ...copyUiDataObject,
                ['actions']: {
                    ...copyUiDataObject?.actions,
                    ['projectPlanOptions']: [...copyUiDataObject?.actions?.projectPlanOptions?.map((pPlanOpt, pPlanIdex) => (pPlanIdex == selectedTaskIndex) ? { ...selectedTask } : { ...pPlanOpt })]
                }
            }
            //let copyObj = copyUiDataObject.actions.projectPlanOptions[selectedTaskIndex] = {...selectedTask}
            setCopyUiDataObject(copyObj);
        }
    }, [selectedTask]);
    useEffect(()=>{
        let i = 0;
        if(isSave.current == true && !(Object.keys(selectedDependentTask).length == 0)){
            if (uiDataObject?.actions?.projectPlanOptions != undefined && uiDataObject?.actions?.projectPlanOptions?.length != 0) {
                let copyObj = {
                    ...uiDataObject,
                    ['actions']: {
                        ...uiDataObject?.actions,
                        ['projectPlanOptions']: [...uiDataObject?.actions?.projectPlanOptions?.map((pPlanOpt, pPlanIdex) => (selectedDependentTaskIndex.includes(pPlanIdex)) ? { ...selectedDependentTask[i++] } : { ...pPlanOpt })]
                    }
                }
                //let copyObj = copyUiDataObject.actions.projectPlanOptions[selectedTaskIndex] = {...selectedTask}
                setUiDataObject(copyObj);
            }
        }  
    },[selectedDependentTask,isSave.current])
    useEffect(() => {
        updateTaskOptions(uiDataObject?.actions?.projectPlanOptions[selectedTaskIndex]?.selectedOptionType);
    }, [selectedTaskIndex])
    useEffect(() => {
        setUiDataObject(JSON.parse(JSON.stringify(simObj)));
        setCopyUiDataObject(JSON.parse(JSON.stringify(simObj)));
        uiDataObjectBckp.current = JSON.parse(JSON.stringify(simObj));
    }, [simObj?.actions])
    useEffect(() => {
        calculateProjectParams();
    }, [copyUiDataObject])

    useEffect(() => {
        svg = d3.select('#aonSvg');
        initiateGraph();
        // calculateProjectParams();
    }, [copyUiDataObject?.laststate?.criticalPath])

    useEffect(()=>{
        if (uiDataObject?.actions?.projectPlanOptions != undefined && uiDataObject?.actions?.projectPlanOptions?.length != 0) {
            let copyObj = {
                ...copyUiDataObject,
                ['actions']: {
                    ...copyUiDataObject?.actions,
                    ['projectPlanOptions']: [...uiDataObject?.actions?.projectPlanOptions]
                }
            }
            //let copyObj = copyUiDataObject.actions.projectPlanOptions[selectedTaskIndex] = {...selectedTask}
            setCopyUiDataObject(copyObj);
        }
    },[uiDataObject?.actions?.projectPlanOptions])
    useEffect(() => {
        // setSelectedDependentTask([]) 
        // setSelectedDependentTaskIndex('');
        svg = d3.select('#aonSvg').attr('width', width).attr('height', height).attr('aria-labelledby', 'svgTitle svgDesc'); //.attr('role', 'img')
        (uiDataObject?.laststate?.tasks.length > 0) && initiateGraph();
        window.$('.textAchor').not("svg").popup({
            inline: true,
            hoverable: true,
            hideOnScroll: 'auto',
            addTouchEvents: true,
            popup: '.graph_info.popup',
            boundary: '.canvas_container',
            onShow: (currentNode) => {
                // let tooltip = document.getElementById('graph_tooltip');
                //  console.log(currentNode);
            },
            onUnplaceable: (currentNode) => {
                let position = currentNode.getBoundingClientRect();
                if (!/Android|iPad/i.test(navigator.userAgent)) {
                    showToolTip(currentNode, position, currentNode.textContent);
                }
            }
        });
        window.$(".ui.modal").modal();
        // window.$(".task-selector-bg.modal").length > 1 && window.$(".task-selector-bg.modal:last-child").remove()
    }, [uiDataObject])

    const initDependantTasks = ()=> {
        let dependentTaskObj = {}
        let tasksInformation = simObjCopy?.tasksInformation
        for (const i in tasksInformation) {
            if (tasksInformation[i].repeatingTasksId.length>0) {
                for (const j in tasksInformation[i].repeatingTasksId) {
                    if(!dependentTaskObj[tasksInformation[i].repeatingTasksId[j]] && !Object.values(dependentTaskObj).includes(tasksInformation[i].repeatingTasksId[j]) && !Object.keys(dependentTaskObj).includes(tasksInformation[i].repeatingTasksId[j])){
                        dependentTaskObj[tasksInformation[i].repeatingTasksId[j]] = tasksInformation[i].taskId
                    }
                }
                
            }
        }
        setDependantTasks(dependentTaskObj)
    }
    useEffect(() => {
        if (showTaskSelectionPopup) {
            document.querySelectorAll("#aon_container a").forEach((item) => {
                item.setAttribute("tabindex", "-1")
            })
        }
        else {
            document.querySelectorAll("#aon_container a").forEach((item) => {
                item.removeAttribute("tabindex")
            })
        }
    }, [selectTask, showTaskSelectionPopup])

    useEffect(() => {
        if (showTaskSelectionPopup && eventType != "") {
            document.querySelector(".taskPopUpHeading").focus();
        }
    }, [showTaskSelectionPopup, eventType])
    // useEffect(()=>{
    //     if(showTaskSelectionPopup){

    //     }
    // },[showTaskSelectionPopup])
    useEffect(() => {
        const handleTaskSelResize = () => {
            const divTaskSelectorElement = document.getElementById('divTaskSelector');
            if (divTaskSelectorElement) {
                if (window.innerWidth <= 360) {
                    divTaskSelectorElement.style.width = '350px';
                } else {
                    divTaskSelectorElement.style.width = '400px';
                }
            }
        };
        handleTaskSelResize();
        window.addEventListener('resize', handleTaskSelResize);
        return () => {
            window.removeEventListener('resize', handleTaskSelResize);
        };
    }, []);
    useEffect(() => {
        const checkStyleTag = () => {
          const styleTag = document.querySelector('style.stylus');
          setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
        };
    
        // Call the check function when the component mounts
        checkStyleTag();
    
        // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
        const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
        return () => clearInterval(intervalId);  // Clean up interval when component unmounts
      }, []);
    //   useEffect(()=>{
    //     if(showTaskSelectionPopup || pmPopup?.firstNode){
    //         document.querySelector(".ui.dimmer.modals").style.height = document.documentElement.scrollHeight + "px";
    //         document.querySelector(".ui.dimmer.modals").style.position = "absolute";
    //         document.querySelector(".ui.task-selector-bg").style.top = "150px";
    //     }
    //   },[showTaskSelectionPopup,pmPopup?.firstNode])

    //  useEffect(() => {
    //     if(window.innerWidth <= 810){
    //         if(pmPopup?.taskSelectorA || pmPopup?.taskSelectorB){
    //         document.querySelector(".ui.task-selector-bg").style.top = "250px";
    //         }
    //     }
    //  }, [pmPopup?.taskSelectorA, pmPopup?.taskSelectorB])
    return (
        <>
            <div className="canvas_container" id="canvas_container" style={{ "float": "left" }}>
                <div id="aon_container" style={{ "float": "left", "position": "relative" }}>
                    {
                        pmPopup?.firstNode && <div className='node-a'><img src={nodeA} /></div>
                    }
                    <svg id="aonSvg" aria-label="Activity-on-Node Diagram, with nodes from A to Z label. Each labels represents activities that are Unplanned, Planned/Not started, in progress, Completed, Inspection &amp; critical path." width="650" height="200" xmlns="http://www.w3.org/2000/svg">
                        <defs id="aonDef">
                            <marker id="red_arrow" viewBox="0 0 10 10" refX="9" refY="3" markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="100" orient="auto">
                                <path d="M0,0 L0,6 L9,3 z" fill="red">
                                </path>
                            </marker>
                            <marker id="grey_arrow" viewBox="0 0 10 10" refX="9" refY="3" markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="100" orient="auto">
                                <path d="M0,0 L0,6 L9,3 z" fill="grey">
                                </path>
                            </marker>
                        </defs>
                    </svg>
                    <div className="ui graph_info popup" id="graph_tooltip" style={{ "max-height": "100vh" }}></div>
                    <div className={`ui task-selector-bg modal`} id="divTaskSelector" style={{ "display": "none", "width": "400px" }} > {/* onClick={() => closeTaskSelectionPopup('close')} */}
                        <div role="dialog" aria-labelledby={`selectedTask_${selectedTask?.taskId}`} className={`task-selector task_${selectedTask?.taskId}`} id="task-selector">
                            <div className="decision-title">
                                <h2 tabindex="-1" id={`selectedTask_${selectedTask?.taskId}`} className="taskPopUpHeading">Task {selectedTask?.taskId} - {selectedTask?.taskName}</h2>
                                <div className="actions">
                                    <a href="javascript:void(0)" role="button" style={{ "float": "left", "position": "relative" }} title="close" id="closePopup" className="ui close-button" onClick={() => closeTaskSelectionPopup('close')}> </a>
                                </div>
                            </div>
                            {
                                (selectedTask?.taskId == 'B' || selectedTask?.taskId == 'H' || selectedTask?.taskId == 'T' || selectedTask?.taskId == 'K' || selectedTask?.taskId == 'W' || selectedTask?.taskId == 'I' || selectedTask?.taskId == 'U') &&
                                <div>
                                    {selectedTask?.taskId == 'B' && <span id="taskBtooltip" className="task_selector_message" >{LANG.TASK_B_TOOLTIP}</span>}
                                    {(selectedTask?.taskId == 'H' || selectedTask?.taskId == 'T') && <span id="taskBtooltip" className="task_selector_message" >{LANG.TASK_H_TOOLTIP}</span>}
                                    {selectedTask?.taskId == 'K' && <span id="taskBtooltip" className="task_selector_message" >{LANG.TASK_K_TOOLTIP}</span>}
                                    {selectedTask?.taskId == 'W' && <span id="taskBtooltip" className="task_selector_message" >{LANG.TASK_W_TOOLTIP}</span>}
                                    {selectedTask?.taskId == 'I' && <span id="taskBtooltip" className="task_selector_message" >{LANG.TASK_I_TOOLTIP}</span>}
                                    {selectedTask?.taskId == 'U' && <span id="taskBtooltip" className="task_selector_message" >{LANG.TASK_U_TOOLTIP}</span>}
                                </div>
                            }
                            <div style={{ "margin-top": "28px", "margin-bottom": "15px" }}>
                                {selectedTask?.taskOptionType != 'NA' && <span>Select {taskOptionType[selectedTask?.taskOptionType]}</span>}
                                {selectedTask?.pmTaskOptions?.length == 3 && <div className="actions" style={{ "float": "right" }}><button className="ui save_tasks" disabled={"simulationStatus" == 'NORMALEXIT' || selectedTask?.taskState == 'COMPLETED' || ((selectedTask?.optionsUpdated || selectedTask?.taskState == 'IN_PROGRESS') && !isTaskOptionChanged)} onClick={() => closeTaskSelectionPopup('save')}>Save</button></div>}
                            </div>
                            <div>
                                <form className="sub_contractors">
                                    {
                                        selectedTask?.pmTaskOptions?.map((task, index) => (
                                            // <div className="actions">
                                            <a key={index} href="javascript:void(0);" role="button" task={JSON.stringify(task)} title={`${task?.companyName} Complete work in ${task?.days > 1 ? `${task?.days} days` : `${task?.days} day`}. Labor cost $${task.cost}.`} className={`ui radio taskDSecisionPopUpAnchorTag ${(!selectedTask.taskOptionAvailable || task.taskState == 'IN_PROGRESS') ? 'sub_contractor_disabled' : ''}`} onClick={() => {
                                                if(!Object.keys(dependentTasks).includes(task?.taskId)){
                                                (!selectedTask?.taskOptionAvailable || task?.taskState == 'IN_PROGRESS') || onHandleSelectTaskOption(task)
                                                }
                                            }
                                            } aria-selected={task?.optionType === selectedTask?.selectedOptionType}>
                                                <div className={`clearfix person-item ${task?.optionType == selectedTask?.selectedOptionType ? 'active_item' : ''}`}>
                                                    <div style={{ "display": "flex" }}>
                                                        <div className="face"><img src={`${require(`../assets/character-portraits/${task.taskId + index}.png`)}`} alt={`${task?.companyName}`} /></div>
                                                        <div className="person-description">
                                                            {/* <span className="screenHidden">{task?.companyName}</span> */}
                                                            <h3 aria-hidden="true">{task?.companyName}</h3>
                                                            <p>
                                                                Complete work in {task?.days > 1 ? `${task?.days} days` : `${task?.days} day`}. Labor cost ${task.cost}.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                            // </div>
                                        ))
                                    }
                                </form>
                                {
                                    selectedTask?.pmTaskOptions?.length > 1 && (<form className={`work_overtime ${PmModuleStyle.work_overtime}`}>
                                        <fieldset>
                                            <legend className="select-title">
                                                <span>Select Expedite options</span>
                                            </legend>
                                            {
                                                selectedTask?.pmTaskOptions?.map((task, index) => (
                                                    task?.optionType == selectedTask?.selectedOptionType && (
                                                        <div key={index} style={{ "display": "flex" }}>
                                                            <input type="checkbox" disabled={!selectedTask?.overTimeOptionAvailable} checked={task?.overTimeSelected} name="overtime" onChange={() => { onHandleChange(task) }} onClick={() => { onHandleChange(task) }} id={`overtime_${index}`} />
                                                            <label htmlFor={`overtime_${index}`}>
                                                                <span class="before sr-only" aria-hidden="true" role="presentation"></span>
                                                                <div className="person-description">
                                                                    <h3>Choose Work Overtime</h3>
                                                                    <p>
                                                                        {/* Costs ${overtimeData?.cost} extra. Reduces task time by {overtimeData?.days > 1 ? `${overtimeData?.days} days` : `${overtimeData?.days} day`}. */}
                                                                        Costs 
                                                                        ${selectedTask?.selectedOptionType == "CHEAPER"
                                                                            ? `${selectedTask?.cheaperOptionOverTimeCost} `
                                                                            : selectedTask?.selectedOptionType == "STANDARD"
                                                                            ? `${selectedTask?.standardOptionOverTimeCost} `
                                                                            : `${selectedTask?.expensiveOptionOverTimeCost} `}
                                                                         extra. Reduces task time by 

                                                                         {/* {overtimeData?.days > 1 ? `${overtimeData?.days} days` : `${overtimeData?.days} day`}. */}
                                                                         {
                                                                         selectedTask?.selectedOptionType === "CHEAPER"
                                                                         ? selectedTask?.cheaperOverTimeDays > 1
                                                                             ? ` ${selectedTask?.cheaperOverTimeDays} days`
                                                                             : ` ${selectedTask?.cheaperOverTimeDays} day`
                                                                         : selectedTask?.selectedOptionType === "STANDARD"
                                                                             ? selectedTask?.standardOverTimeDays > 1
                                                                                 ? ` ${selectedTask?.standardOverTimeDays} days`
                                                                                 : ` ${selectedTask?.standardOverTimeDays} day`
                                                                             : selectedTask?.expensiveOverTimeDays > 1
                                                                                 ? ` ${selectedTask?.expensiveOverTimeDays} days`
                                                                                 : ` ${selectedTask?.expensiveOverTimeDays} day`
                                                                         }.
                                                                    </p>
                                                                </div>
                                                                <span class="after sr-only" aria-hidden="true" role="presentation"></span>
                                                            </label>
                                                        </div>)
                                                ))
                                            }
                                            {
                                                selectedTask?.pmTaskOptions?.map((task, index) => (
                                                    task?.optionType == selectedTask?.selectedOptionType && (
                                                        <div key={index} style={{ "display": "flex" }}>
                                                            <input type="checkbox" disabled={!selectedTask?.localSupplierOptionAvailable} checked={task?.localSupplierSelected} name="supplier" onChange={() => { onHandleChange(task) }} onClick={() => { onHandleChange(task) }} id={`localSupplier_${index}`} />
                                                            <label htmlFor={`localSupplier_${index}`}>
                                                                <span class="before sr-only" aria-hidden="true" role="presentation"></span>
                                                                <div className="person-description">
                                                                    {/* <h3>{supplierData?.suppilerName}</h3> */}
                                                                    <h3>{selectedTask?.localSuppilerOptionName}</h3>
                                                                    <p>
                                                                        {/* Costs ${supplierData?.cost} extra. Reduces task time by {supplierData?.days > 1 ? `${supplierData?.days} days` : `${supplierData?.days} day`}. */}
                                                                        Costs ${selectedTask?.localSupplierCost} extra. Reduces task time by {selectedTask?.localSupplierDays > 1 ? `${selectedTask?.localSupplierDays} days` : `${selectedTask?.localSupplierDays} day`}.
                                                                    </p>
                                                                </div>
                                                                <span class="after sr-only" aria-hidden="true" role="presentation"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                ))
                                            }
                                        </fieldset>
                                    </form>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div id="aonSvgDataLabels" className="screenHidden" aria-hidden="true"></div>
                <div className={`aonSvgDataLabels`} style={{ "float": "left", "width": "100%", "display": "flex" }} >
                    <svg height="50" width={(isStyleTagPresent && isChrome) ? "190" : "155"} style={{ "overflow": "initial" }} className={`${pmPopup?.aonLabels ? `show ${PmModuleStyle['show']}` : ''}`}>
                        <circle cx="10" cy="10" r="5" stroke="#000000" stroke-width="2" fill="#FFF"></circle>
                        <text x="20" y="15" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Unplanned</text>
                        <circle cx="10" cy="25" r="5" stroke="#000000" stroke-width="1" fill="#D4EAE4"></circle>
                        <text x="20" y="30" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Planned / Not Started</text>
                        <circle cx="10" cy="40" r="5" stroke="#000000" stroke-width="1" fill="#12B2A6"></circle>
                        <text x="20" y="45" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>In Progress</text>
                        {/* Sorry, your browser does not support inline SVG. */}
                    </svg>
                    <svg height="50" width="100" style={{ "overflow": "initial" }} className={`${pmPopup?.aonLabels ? `show ${PmModuleStyle['show']}` : ''}`}>
                        <polygon points="7.5,0 15,7.5 7.5,15 0,7.5" stroke="#000000" stroke-width="1" fill="#EA7600" />
                        <text x="20" y="30" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Completed</text>
                        <circle cx="10" cy="25" r="5" stroke="#000000" stroke-width="1" fill="#008638"></circle>
                        <text x="20" y="15" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Inspection</text>
                        {/* Sorry, your browser does not support inline SVG. */}
                    </svg>
                    <svg height="50" width="145"  style={{ "overflow": "initial" }} className={`${pmPopup?.aonPaths || pmPopup?.aonLabels ? `show ${PmModuleStyle['show']}` : ''}`}>
                        <line x1="0" y1="10" x2="17" y2="10" stroke-dasharray="3,3" stroke="#DB0020" stroke-width="1" marker-end="url(#red_arrow)"></line>
                        <text x="20" y="15" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Critical Path</text>
                        <line x1="0" y1="25" x2="17" y2="25" stroke-dasharray="3,3" stroke="gray" stroke-width="1" marker-end="url(#grey_arrow)"></line>
                        <text x="20" y="30" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Normal Path</text>
                        <line x1="0" y1="45" x2="17" y2="45" stroke="#DB0020" stroke-width="1" marker-end="url(#red_arrow)"></line>
                        <line x1="0" y1="38" x2="17" y2="38" stroke="gray" stroke-width="1" marker-end="url(#grey_arrow)"></line>
                        <text x="20" y="45" fill="#505759" font-family="Roboto, 'Helvetica Neue', Helvetica, Arial" font-size="13" style={{ display: "block" }}>Completed Path</text>
                        {/* Sorry, your browser does not support inline SVG. */}
                    </svg>
                </div>
            </div>
        </>
    )
}

export default AonGraph